<template>
    <div class="catalogue">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem>首页</BreadcrumbItem>
                    <BreadcrumbItem> 现场广告征订表</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">现场广告征订表</div>
            </div>
            <div class="header-tool-box">
                <div class="htb-item" @click="goOne">
                    <span>返回首页</span>
                </div>
            </div>
        </div>
        <div class="marginCss20">
            <p v-if="formList[0]&&formList[0].value" class="fontWig">截止日期：{{ formList[0].value }}</p>
            <div  class="paddingCss20 backBlue marginTop20">
                <p v-if="formList[3]&&formList[3].value" v-html="formList[3].value"></p>
            </div>
        </div>


    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";


export default {
    name: "exhibition-info-catalogue",
    data () {
        return {
            formList: [],
            loading: false,
            list: [
                { name: '光地', remark: false, },
                { name: '增加展墙', remark: false, },
                { name: '拆除展墙，请注明要拆除的展墙两侧的展位号', remark: false, },
                { name: '其它要求', otherRemark: "" },
            ]
        };
    },
    components: {
    },
    computed: {
        ...mapGetters({
            formHeaders: "getFormHeaders",
            uploadUrl: "getUploadUrl",
            joinInfo: "loginModule/getJoinInfo",
            company: "loginModule/getCompany",
            exhibition: "loginModule/getExhibition",

            exhibitor: "loginModule/getExhibitor",
        }),
        exhibitionId () {
            return this.exhibition.id;
        },
    },
    created () {
         
        this.init();
    },
    methods: {
        ...mapActions({

            downFile: "exhibitionModule/downFile",

            setManageSettingQ: 'hostSetModule/setManageSettingQ', //
            standardboothconstructionchangerecordPost: "exhibitionModuleY/standardboothconstructionchangerecordPost",
            standardboothconstructionchangerecordGet: "exhibitionModuleY/standardboothconstructionchangerecordGet",
        }),
        goOne () {
            this.$router.push(`/exhibition/index/home`);

        },

        async init () {
            let opt = {
                providerName: "Global",
                // providerKey: this.exhibition.id,
                names: ['SceneAdvert.SubmitDeadline', 'SceneAdvert.IsSubmitDeadlineToo', 'SceneAdvert.IsRequired', 'SceneAdvert.FormDescription', 'SceneAdvert.ContractDescription']

            }
            let res = await this.setManageSettingQ(opt)
            if (res) {
                this.formList = res
            }
        },
   

   


    },
};
</script>

<style lang="scss">
.intTextarea {
    .ivu-form-item-error-tip {
        top: 75%;
    }
}

.no-label {
    .ivu-form-item-label:before {
        opacity: 0 !important;
    }
}
</style>
<style scoped lang="scss"></style>
